var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJlrBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176.005,
    height: 154.824,
    viewBox: "0 0 176.005 154.824",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Jaguar_Land_Rover_JLR",
    "data-name": "Jaguar Land Rover JLR",
    transform: "translate(-144.99 -54.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6158",
    "data-name": "Path 6158",
    d: "M156.229,54.73h13.994c.105,40.509.022,81.025.022,121.534a39.3,39.3,0,0,1-18.021,33.291H152.2q-5.93-9.537-7.139-11.466a.359.359,0,0,1-.067-.163,26.141,26.141,0,0,0,9.272-11.262,27.484,27.484,0,0,0,1.955-10.178Q156.226,115.6,156.229,54.73Z",
    transform: "translate(0 0)",
    fill: "#99a8b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6159",
    "data-name": "Path 6159",
    d: "M313.966,54.73h14.007q.033,58.592.01,117.182a.078.078,0,0,0,.077.077h55.964a.149.149,0,0,1,.121.067l8.354,13.56c.01.016.006.025-.016.025H314a.042.042,0,0,1-.041-.041Z",
    transform: "translate(-115.095 0)",
    fill: "#99a8b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6160",
    "data-name": "Path 6160",
    d: "M447.322,54.73h38.733c19.312.561,36.221,15.627,36.626,35.484.4,19.392-13.258,34.464-32.27,36.881a.038.038,0,0,0-.032.041c0,.006,0,.01.006.016l36.422,58.466v.029l-14.909-.006a.106.106,0,0,1-.089-.051l-36.192-58a.187.187,0,0,0-.163-.089q-14.214-.062-28.234-.01a.079.079,0,0,1-.08-.08h0V113.9a.057.057,0,0,1,.057-.057q19.126,0,38.255-.022A22.434,22.434,0,0,0,506.419,100.1a23.131,23.131,0,0,0-2.111-22.077,22.444,22.444,0,0,0-17.291-9.578c-.941-.054-1.881-.083-2.822-.08q-18.37.019-36.817.019a.064.064,0,0,1-.064-.064Z",
    transform: "translate(-205.811 0)",
    fill: "#99a8b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJlrBlue);
export default __webpack_public_path__ + "static/media/JLR_blue.00ad925d4af3697cf9b37b6a4b35f490.svg";
export { ForwardRef as ReactComponent };